<template>
  <div class="btn" @click="toTop" v-show="!isShow">
    <i class="el-icon-arrow-up"></i>
  </div>
</template>

<script>
export default {
  name: "RightButton",
  data(){
    return {
      isShow: true
    }
  },
  created(){
    //开启监听页面滚动
    window.addEventListener("scroll",this.getTop)
    this.getTop()
    console.log("%cBackTop","background: #70DB93;")
  },
  methods: {
    //回到顶部
    toTop(){
      // 定时器
      let timer = setInterval(()=>{
        // 判断是否到顶
        if(scrollY > 0){
          // 滚动到指定位置
          let goNum = Math.floor(window.scrollY - 10)
          window.scrollTo(0,goNum)
        }else{
          // 到顶清除定时器
          clearInterval(timer)
        }
      },0)
    },
    //监听页面滚动的回调函数
    getTop(){
      if(window.scrollY > 600) this.isShow = false
      else this.isShow = true
    }
  },
  beforeDestroy(){
    //关闭监听页面滚动
    window.removeEventListener("scroll",this.getTop)
  }
}
</script>

<style scoped>
  .btn{
    width: 50px;
    height: 50px;
    z-index: 1314;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(0,0,0,.4);
    position: fixed;
    right: 20px;
    bottom: 20vh;
    border-radius: 50%;
    text-align: center;
  }
  .btn i{
    font-size: 35px;
    line-height: 50px;
  }
</style>